module.exports = __webpack_public_path__ + "f6a4667793798af8a984d98e92317305.MP3";